<template>
  <div ref="pieChart"></div>
</template>

<script>
import * as echarts from 'echarts/core';
import { PieChart } from 'echarts/charts';
import { TitleComponent, TooltipComponent, LegendComponent } from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([TitleComponent, TooltipComponent, LegendComponent, PieChart, CanvasRenderer]);

export default {
  name: 'PieChart',
  props: {
    chartData: {
      type: Array,
      required: true
    },
    chartColors: {
      type: Array,
      required: true
    },
    chartField: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      handler(newData) {
        this.updateChart(newData, this.chartColors, this.chartField);
      },
      deep: true
    },
    chartColors: {
      handler(newData) {
        this.updateChart(this.chartData, newData, this.chartField);
      },
      deep: true
    },
    chartField: {
      handler(newData) {
        this.updateChart(this.chartData, this.chartColors, newData);
      },
      deep: true
    }
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$refs.pieChart);
      this.updateChart(this.chartData, this.chartColors, this.chartField);
    },
    updateChart(data, colors, field) {
      let option = this.generateChartPie(data, colors, field);
      this.chart.setOption(option);
    },

    generateChartPie(data, colors, field) {
      return {
        tooltip: { show: !1 },
        legend: { orient: "horizontal", top: "5%", right: "0%", itemGap: 20 },
        series: [
          {
            name: "",
            type: "pie",
            stillShowZeroSum: false,
            radius: ["30%", "60%"],
            center: ["40%", "55%"],
            avoidLabelOverlap: !1,
            itemStyle: { borderRadius: 10, borderColor: "#fff", borderWidth: 0 },
            label: {
              show: !0,
              align: "left",
              formatter: function (e) {
                let t = e.name,
                  i = e.value,
                  n = i,
                  r = n;
                if ("traffic" == field) {
                  let e = "MB";
                  i > 1e6
                    ? ((n = i / 1e6), (e = "TB"))
                    : i > 1e3 && ((n = i / 1e3), (e = "GB")),
                    ("TB" !== e && "GB" !== e) || (n = Math.round(100 * n) / 100),
                    (r = n + e);
                } else if ("date" == field) {
                  r = n + "DAY";
                }
                return `${t} \n ${r}`;
              },
            },
            data: data,
          },
        ],
        color: colors,
      };
    },
  }
};
</script>

<style scoped>
</style>
